import React, { useEffect, useState } from "react";
import "../styles/ScrollProgressBar.css";

// Self-contained top-of-page reading progress bar. Fills left-to-right
// as the user scrolls down any page — sits above the floating navbar.
export default function ScrollProgressBar() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const updateProgress = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      setProgress(Math.min(100, Math.max(0, pct)));
    };

    updateProgress();
    window.addEventListener("scroll", updateProgress, { passive: true });
    window.addEventListener("resize", updateProgress);
    return () => {
      window.removeEventListener("scroll", updateProgress);
      window.removeEventListener("resize", updateProgress);
    };
  }, []);

  return (
    <div className="tp-scroll-progress" aria-hidden="true">
      <div
        className="tp-scroll-progress__bar"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
